module.exports = __webpack_public_path__ + "img/bg-png-01.2afe854f.png";